var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import * as CodeMirror from 'codemirror';
import { INJECT_UICORE_AICONTEXT, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import 'codemirror/mode/javascript/javascript';
import './mode/interopable-string';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/runmode/runmode';
import 'codemirror/addon/edit/closebrackets';
import { uicoreExprInputHint } from './addon/uicore-expr-input-hint';
import "./index.css";
import ExprInputCompletionProvider, { INJECT_EXPR_INPUT_COMPLETION_PROVIDER_KEY } from './ExprInputCompletionProvider';
import { InlineCodeMirrorBase } from '../InlineCodeMirrorBase/index';
import { throttle } from "lodash-es";
import { CodeMirrorJsErrorChecker } from './CodeMirrorJsErrorChecker';
import { splitInteropableString } from "../../../lib/utils/script/interopableString";
import { ICMBTButton } from '../InlineCodeMirrorBase/ICMBTButton';
import { installCodeMirrorAiWidget } from "../../../lib/comps/ExprInput/addon/uicore-expr-input-ai";
let ExprInput = class ExprInput extends InlineCodeMirrorBase {
  constructor() {
    super(...arguments);
    this.hasReturnStatement = true;
    this.jsDoubleBrace = false;
    this.jsParts = [];
    this.jsErrorCheckerResult = [];
    this.aiMaskVisible = false;
  }
  // 由于 ExprInput 直接接受 DataStub 参数，所以可能还要再组装一个 Provider
  get finalExprInputCompletionProvider() {
    const {
      inheritedExprInputCompletionProvider,
      dataStub
    } = this;
    if (!dataStub) return inheritedExprInputCompletionProvider;
    return new ExprInputCompletionProvider({
      parent: inheritedExprInputCompletionProvider || undefined,
      propsData: {
        dataStub
      }
    });
  }
  get cmOptions() {
    const ans = {
      mode: this.type,
      hintOptions: {
        hint: uicoreExprInputHint,
        getCompletionProvider: () => this.finalExprInputCompletionProvider,
        completeSingle: false
      },
      extraKeys: {
        'Ctrl-Space': 'autocomplete'
      },
      ...this.$attrs.cmOptions
    };
    return ans;
  }
  get popupTitle() {
    if (this.$attrs.popupTitle) return this.$attrs.popupTitle;
    return this.type === 'javascript' ? 'JavaScript 编辑器' : '插值表达式编辑器';
  }
  get toolbar() {
    const h = this.$createElement;
    return [h(ICMBTButton, {
      "attrs": {
        "icon": "lightbulb-o",
        "title": "显示自动补全 (Ctrl-Space)"
      },
      "on": {
        "click": this.focusAndShowHints
      }
    }), h(ICMBTButton, {
      "attrs": {
        "icon": "paint-brush",
        "title": "格式化代码"
      },
      "on": {
        "click": this.formatText
      }
    }), !!this.jsErrorCheckerResult.length && h(ICMBTButton, {
      "attrs": {
        "alwaysShow": true,
        "icon": "warning",
        "title": '有语法错误，点击跳转'
      },
      "class": "isError",
      "on": {
        "click": this.jumpNextError
      }
    }), this.jsDoubleBrace && h(ICMBTButton, {
      "attrs": {
        "alwaysShow": true,
        "icon": "warning",
        "title": '输入框左边有 JS标志 时，无需双花括号，直接写表达式'
      },
      "class": "isError",
      "on": {
        "click": this.removeBrace
      }
    })];
  }
  focusAndShowHints() {
    this.cm.focus();
    this.showHintDebounced();
  }
  beforeDestroy() {
    this.updateJsPartsFromCurrentValue.cancel();
  }
  onCmReady(cm) {
    cm.on('keypress', this.handleKeyPress);
    cm.on('mousedown', () => {
      if (cm.getValue() === '') this.showHintDebounced();
    });
    this.jsErrorChecker = new CodeMirrorJsErrorChecker(this, cm);
    this.updateJsPartsFromCurrentValue();
    cm.on('changes', this.updateJsPartsFromCurrentValue);
    cm.on('mousedown', this.updateJsPartsFromCurrentValue);
    this.$on('change', this.updateJsPartsFromCurrentValue);
    this.uicoreAiContext && installCodeMirrorAiWidget(cm, this.uicoreAiContext, this);
    this.$emit('cmReady', cm);
  }
  handleKeyPress(cm, ev) {
    let shallShowHint = /^[ .\w{([,$]$/.test(ev.key);
    if (!shallShowHint && ev.key === ' ') {
      const pos = cm.getCursor();
      shallShowHint = cm.getRange(new CodeMirror.Pos(pos.line, pos.ch - 2), pos) === '{{';
    }
    if (shallShowHint) {
      this.showHintDebounced();
    }
  }
  get logo() {
    const h = this.$createElement;
    if (this.hideIcon) return null;
    if (this.type === 'javascript') {
      return (// <img
        //   src={JSLogo}
        //   alt=""
        //   class="ucd-exprInput-typeLogo"
        //   title="请输入 JavaScript 表达式，可直接使用页面上的变量"
        // />
        h("div", {
          "class": 'ucd-exprInput-js-logo',
          "attrs": {
            "title": "请输入 JavaScript 表达式，可直接使用页面上的变量"
          }
        }, ["JS"])
      );
    }
    // if (this.type === 'interopable-string' && this.tempValue.includes('{{')) {
    //   return (
    //     <img
    //       src={StringLogo}
    //       alt=""
    //       class="ucd-exprInput-typeLogo"
    //       title="请输入一个字符串，中间可使用 {{ xxx }} 进行插值。花括号内为 JavaScript 表达式"
    //     />
    //   );
    // }
    return null;
  }
  get bottomNotices() {
    const h = this.$createElement;
    const {
      type,
      notifyVoidReturn
    } = this;
    // 此处返回的 root dom 类型不一致时会存在问题，Fragment 对于 children 作了 froze 的原因
    if (!notifyVoidReturn) return;
    // 存在编辑器提示的语法错误时，不提示
    if (type === 'javascript' && !this.hasReturnStatement && !this.jsErrorCheckerResult.length && !this.jsDoubleBrace) {
      return h("div", {
        "class": 'ucd-exprInput-js-void-return-notify'
      }, ["\u8BF7\u4F7F\u7528 return \u8FD4\u56DE\u6240\u9700\u8981\u7684\u503C"]);
    }
  }
  get updateJsPartsFromCurrentValue() {
    return throttle(() => {
      var _this$jsErrorChecker;
      const parts = [];
      const {
        type
      } = this;
      const value = this.cm.getValue();
      if (type === 'javascript') {
        if (value) {
          this.jsDoubleBrace = /^(\{\{)(.*?)(\}\})$/.test(value.trim());
          parts.push({
            from: 0,
            text: value
          });
        }
      }
      if (type === 'interopable-string') {
        const {
          parts: parsedParts,
          offsets
        } = splitInteropableString(value);
        for (let i = 1; i < parsedParts.length; i += 2) {
          const text = parsedParts[i];
          const from = offsets[i];
          if (text && !/^\s+$/.test(text)) parts.push({
            from,
            text
          });
        }
      }
      if (this.jsParts.length === 0 && parts.length === 0) return;
      this.jsParts = Object.seal(parts);
      let lackingReturn = false;
      (_this$jsErrorChecker = this.jsErrorChecker) === null || _this$jsErrorChecker === void 0 || _this$jsErrorChecker.check(parts).then(allResults => {
        const allErrors = [];
        allResults === null || allResults === void 0 || allResults.parts.forEach((result, index) => {
          allErrors.push(...result.errors);
          if (!lackingReturn && !result.returnStatements.length) {
            // 有一种可能，整个就是个表达式
            // 这种情况是可以被 addReturnKeywordIfNeeded 给hold住的
            const canAddReturnKeyword = result.wholeIsExpression // 整个脚本内容都是表达式
            && !parts[index].text.slice(result.wholeIsExpression.end - 1).includes(';'); // 表达式后面没有分号
            if (!canAddReturnKeyword) {
              lackingReturn = true;
            }
          }
        });
        this.jsErrorCheckerResult = Object.seal(allErrors);
        this.hasReturnStatement = !lackingReturn;
      });
    }, 500);
  }
  async formatText() {
    var _this$jsErrorChecker2;
    this.updateJsPartsFromCurrentValue.flush();
    const formatted = await ((_this$jsErrorChecker2 = this.jsErrorChecker) === null || _this$jsErrorChecker2 === void 0 ? void 0 : _this$jsErrorChecker2.format(this.jsParts));
    if (!formatted) return;
    this.tempValue = formatted;
    this.commitDebounced();
  }
  jumpNextError() {
    const {
      cm
    } = this;
    const errors = this.jsErrorCheckerResult;
    if (!cm || !errors.length) return;
    const curPos = cm.indexFromPos(cm.getCursor());
    const nextErr = errors.find(e => e.pos > curPos) || errors[0];
    const newCursor = cm.posFromIndex(nextErr.pos);
    cm.setCursor(newCursor);
    cm.focus();
  }
  removeBrace() {
    const tempVal = this.jsParts[0].text;
    const newVal = tempVal.slice(2, tempVal.length - 2);
    this.cm.setValue(newVal);
  }
  renderAiMask() {
    const h = this.$createElement;
    if (!this.designer) return;
    if (!this.uicoreAiContext) return;
    const renderContext = () => h("div", [h("span", {
      "style": "pointer-events:none"
    }, ["ai\u751F\u6210\u4E2D ", h("a-spin", {
      "attrs": {
        "size": "small"
      }
    })]), h("a-button", {
      "attrs": {
        "type": "link",
        "size": 'small'
      },
      "on": {
        "click": () => this.$emit('cancelAi')
      }
    }, ["\u53D6\u6D88"])]);
    return h("div", {
      "class": 'ucd-exprInput-ai-mask vue-codemirror-edit',
      "style": !this.aiMaskVisible && 'display:none'
    }, [this.aiMaskVisible && renderContext()]);
  }
  render() {
    const h = arguments[0];
    const baseClass = this.getInlineCodeMirrorBaseClassName();
    return h("div", {
      "key": "input",
      "class": `${baseClass} ucd-exprInput`,
      "attrs": {
        "data-expr-input-mode": this.type
      }
    }, [this.logo, this.renderInlineCodeMirrorBase({
      content: [this.renderAiMask()]
    }), this.bottomNotices]);
  }
};
ExprInput = __decorate([Component({
  name: 'ExprInput',
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    },
    inheritedExprInputCompletionProvider: {
      from: INJECT_EXPR_INPUT_COMPLETION_PROVIDER_KEY,
      default: null
    },
    uicoreAiContext: {
      from: INJECT_UICORE_AICONTEXT,
      default: null
    }
  },
  props: {
    type: {
      type: String,
      default: 'javascript'
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    dataStub: {
      default: null
    },
    notifyVoidReturn: {
      type: Boolean,
      default: false
    } // 输入了返回为空的函数体时，是否提示
  }
})], ExprInput);
export default ExprInput;
//# sourceMappingURL=index.js.map
